<div class="share-settings-container">
    <div class="header-wrapper" [ngClass]="{ 'column-display': inViewPage }">
        <div
            class="title-container"
            [ngClass]="{ 'close-wrapper': inViewPage }"
        >
            <div class="title-container">
                <div data-cy="user-share-title">
                    {{ "page-access.settings.title" | translate }}
                </div>
                <div style="position: relative">
                    <mat-icon
                        data-cy="user-share-info-icon"
                        class="info-icon"
                        svgIcon="info"
                        (click)="openPageTypeInfo($event)"
                    />
                    <div
                        *ngIf="showInfoPageType"
                        class="info-container"
                        #pageTypeInfo
                    >
                        <div>
                            {{
                                "page-access.type-information.first" | translate
                            }}
                        </div>
                        <div>
                            {{
                                "page-access.type-information.second"
                                    | translate
                            }}
                        </div>
                    </div>
                </div>
            </div>
            <mat-icon
                data-cy="user-share-x-icon"
                *ngIf="inViewPage"
                class="close-icon"
                svgIcon="cancel-close"
                (click)="handleCancel()"
            />
        </div>
        <div class="lock-container">
            <div
                data-cy="user-share-public"
                class="lock-option"
                [ngClass]="{
                    selected: isPublic,
                    'disabled-options': disableLockOptions() && !isCreating,
                }"
                (click)="updateShareSetting()"
            >
                <mat-icon class="lock-icon" svgIcon="lock-open" />
                <div>{{ "page-access.type.public" | translate }}</div>
            </div>
            <div
                data-cy="user-share-private"
                class="lock-option"
                [ngClass]="{
                    selected: !isPublic,
                    'disabled-options': disableLockOptions() && !isCreating,
                }"
                (click)="updateShareSetting()"
            >
                <mat-icon class="lock-icon" svgIcon="lock-closed" />
                <div>{{ "page-access.type.private" | translate }}</div>
            </div>
        </div>
    </div>

    <div
        *ngIf="!isPublic"
        class="title-container"
        (click)="showUsersOptions = !showUsersOptions"
        style="cursor: pointer; width: fit-content"
    >
        <mat-icon class="lock-icon white" svgIcon="lock-closed" />
        <div data-cy="user-share-dropdown-label">
            {{ "page-access.access-options.title" | translate }}
        </div>
        <mat-icon
            data-cy="user-share-dropdown"
            class="arrow-icon"
            svgIcon="icon-down"
            [ngStyle]="{ transform: showUsersOptions ? 'rotate(180deg)' : '' }"
        />
        <div style="position: relative">
            <mat-icon
                data-cy="user-share-info-icon"
                class="info-icon"
                svgIcon="info"
                (click)="openAccessTypeInfo($event)"
            />
            <div
                *ngIf="showInfoAccessType"
                class="info-container"
                #accessTypeInfo
            >
                <div>
                    {{ "page-access.information.first-paragraph" | translate }}
                </div>
                <div>
                    {{ "page-access.information.second-paragraph" | translate }}
                </div>
                <div>
                    {{ "page-access.information.third-paragraph" | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="showUsersOptions && !isPublic">
    <div class="user-container" *ngFor="let roleType of roleTypeArray">
        <app-user-share-settings
            [role]="roleType.role"
            [roleId]="roleType.id"
            [inViewPage]="inViewPage"
            [accessLevel]="usersPermissions[roleType.id]"
            [isCreatingPage]="isCreating"
            [optionsDisabled]="disableLockOptions() && !isCreating"
            (onUserAccessChanged)="handleUserAccessChanged($event)"
        >
        </app-user-share-settings>
    </div>
</div>

<div *ngIf="inViewPage" class="buttons-container">
    <button
        data-cy="user-share-cancel-button"
        class="action-button"
        (click)="handleCancel($event)"
    >
        {{ "page-access.button.cancel" | translate }}
    </button>
    <button
        data-cy="user-share-confirm-button"
        class="action-button"
        (click)="savePermissions($event)"
        [disabled]="disableSaveButton()"
    >
        {{ "page-access.button.confirm" | translate }}
    </button>
</div>

<!-- Cancel Overlay -->
<app-confirmation-window
    #leavePageOverlay
    [mainLabel]="'page-access.confirmation-prompt.main-label' | translate"
    [confirmLabel]="
        'page-access.confirmation-prompt.confirm-button' | translate
    "
    [cancelLabel]="'page-access.confirmation-prompt.cancel-button' | translate"
></app-confirmation-window>
